/** Role permission helpers (mirrors backend ROLE_MATRIX) */

export const ROLE_SECTIONS = {
  admin: [
    'dashboard', 'applications', 'members', 'unemployed', 'manualPayers',
    'cdas', 'scott', 'transactions', 'subscribers', 'users', 'system', 'memberAccounts', 'audit',
  ],
  supervisor: [
    'dashboard', 'applications', 'members', 'unemployed', 'manualPayers',
    'cdas', 'scott', 'transactions', 'subscribers', 'audit',
  ],
  marketing: [
    'dashboard', 'applications', 'members', 'unemployed', 'manualPayers',
    'cdas', 'scott', 'subscribers',
  ],
  accountant: ['dashboard', 'transactions'],
  viewer: [
    'dashboard', 'applications', 'members', 'unemployed', 'manualPayers',
    'cdas', 'scott', 'transactions', 'subscribers',
  ],
};

export const getPermissions = (role) => {
  const r = role || 'viewer';
  const sections = ROLE_SECTIONS[r] || ROLE_SECTIONS.viewer;
  const canWrite = ['admin', 'supervisor', 'marketing', 'accountant'].includes(r);
  const canDelete = ['admin', 'supervisor'].includes(r);
  const isSystemAdmin = r === 'admin';

  return {
    role: r,
    sections,
    canAccess: (section) => sections.includes(section),
    canWrite: (section) => canWrite && sections.includes(section),
    canDelete: (section) => canDelete && sections.includes(section),
    isSystemAdmin,
    /** Legacy: anyone who can mutate at least one operational section */
    canMutate: canWrite,
  };
};
